
define(
	'Code25.CaterpartsGlobal.Loader'
	, [
		"underscore", "jQuery"
	]
	, function (
		_, jQuery
	) {
		'use strict';

		return {
            mount: function (container) {

                jQuery(document).ready(function () {

                    var $body = jQuery(document.body), $loading_icon;
					jQuery("#loadingIndicator").remove();
                    if (!(SC && SC.ENVIRONMENT && SC.ENVIRONMENT.isTouchEnabled)) {

                        var $loading_html = '<div id="loadingIndicator" style="display:none!important;left:0;top:0;width:0;height:0;"></div><div id="loadingIndicator2" ><div class="lds-ring"><div></div><div></div><div></div><div></div></div></div>';

                        $loading_icon = jQuery($loading_html).hide();

                        if (!_.result(SC, 'isPageGenerator')) {
                            $loading_icon.appendTo($body);
                        }
                    }
                    SC.$loadingIndicator = $loading_icon;
                });

                SC.loadingIndicatorShow = function (e) {

                    var $spinners=jQuery(".infinite-spinner");
                    if($spinners.length==0){
                    SC.$loadingIndicator && SC.$loadingIndicator.show();
                    }
                };

                SC.loadingIndicatorHide = function (e) {
                    SC.$loadingIndicator && SC.$loadingIndicator.hide();
                };

                jQuery(document)
                    .ajaxStart(SC.loadingIndicatorShow)
                    .ajaxStop(SC.loadingIndicatorHide);
					

            }
        };

	});
